import { Lightning } from '@lightningjs/sdk'

import { getColor, grey50, grey600, grey700, grey960 } from '../../constants/colors'
import { UniNeueBold, UniNeueRegular } from '../../constants/fonts'
import { BORDER_RADIUS } from '../../constants/general'
import { AppConfig } from '../../services/appConfig'
import { getText } from '../../utils/dictionary'
import SpeechComp from '../speechComp/speechComp'

export class LiveScoresToggle extends SpeechComp {
  private _ttsText = ''

  static _template() {
    return {
      w: 808,
      h: 137,
      rect: true,
      color: getColor(grey700),
      collision: true,
      shader: {
        type: Lightning.shaders.RoundedRectangle,
        radius: BORDER_RADIUS,
      },
      flex: { direction: 'row', alignItems: 'center' },
      Setting: {
        w: 640,
        flex: { direction: 'column' },
        flexItem: { marginRight: 59, marginLeft: 32 },
        Title: {
          text: {
            text: getText('liveScoresSettingTitle'),
            fontSize: 32,
            fontFace: UniNeueBold,
            textColor: getColor(grey50),
          },
        },
        Description: {
          text: {
            text: getText('liveScoresSettingDesc'),
            fontSize: 28,
            fontFace: UniNeueRegular,
            textColor: getColor(grey50),
          },
        },
      },
      Status: {
        text: {
          text: '',
          fontSize: 24,
          fontFace: UniNeueBold,
          textColor: getColor(grey50),
          lineHeight: 28,
        },
      },
    }
  }

  get settingTitle() {
    return this.tag('Title')
  }

  set title(v: string) {
    this.settingTitle.text.text = v
  }

  get settingDescription() {
    return this.tag('Description')
  }

  set description(v: string) {
    this.settingDescription.text.text = v
  }

  get status() {
    return this.tag('Status')
  }

  get speechText(): string {
    return this._ttsText
  }

  _init() {
    const baseText = `${getText('liveScoresSettingTitle')} . . ${getText(
      'liveScoresSettingDesc',
    )} . .`
    const statusText = AppConfig.shared.appSettings.areLiveScoresEnabled()
      ? getText('on')
      : getText('off')

    this._ttsText = `${baseText} ${statusText}`

    this.status.text.text = statusText
  }

  _focus() {
    this.focusItem(true)
    this.speak()
  }

  _unfocus() {
    this.focusItem(false)
  }

  _handleEnter() {
    this.toggleLiveScores()
  }

  focusItem(isFocused: boolean) {
    this.patch({
      color: isFocused ? getColor(grey50) : getColor(grey700),
      Setting: {
        Title: {
          text: {
            textColor: isFocused ? getColor(grey960) : getColor(grey50),
          },
        },
        Description: {
          text: {
            textColor: isFocused ? getColor(grey600) : getColor(grey50),
          },
        },
      },
      Status: {
        text: {
          textColor: isFocused ? getColor(grey960) : getColor(grey50),
        },
      },
    })
  }

  toggleLiveScores() {
    const status = AppConfig.shared.appSettings.areLiveScoresEnabled()
    AppConfig.shared.appSettings.toggleLiveScores(!status)
    this.status.text.text = status ? getText('off') : getText('on')
    SpeechComp.speakCustom(this.status.text.text)
  }

  _handleHover() {
    this._focus()
  }

  _handleUnhover() {
    this._unfocus()
  }

  _handleClick() {
    this._handleEnter()
  }
}
